import {uniqueId, result} from 'lodash';

export default class DatasetAttributeModel {
    type = '';
    datasetId = null;
    column = null;
    display = '';

    constructor({
        datasetId,
        id = uniqueId('dataset_attribute_'),
        column = null,
        display = '',
    } = {}) {
        Object.assign(this, {id, display, datasetId});
        this.setColumn(column);
    }

    setColumn(column) {
        this.column = column;
    }

    setAggregation() {
        // pass
    }

    isComplete() {
        return !!this.column;
    }

    get label() {
        return result(this.column, 'fullName', '');
    }
}
